import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const trainYourBot = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/trainApp', METHOD_TYPES.POST, data, callback);
};

export const publishYourBot = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/publishApp', METHOD_TYPES.POST, data, callback);
};

export const voteChatlog = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/voteChatlog', METHOD_TYPES.PUT, data, callback);
};

export const whatsAppFileUpload = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/whatsappInputFileUpload', METHOD_TYPES.POST, data, callback, 20000, "multipart/form-data");
};

export const updateTagsInConversations = (data, callback) => {
  return fetchDataAndProceed('/admin/v1/chatLogs/updateTags', METHOD_TYPES.PUT, data, callback);
}


// WEBPACK FOOTER //
// ./src/data/redux/page_details/api.js